export const YMAPS_KEY_MISSING_ERROR = 'Не задан ключ Яндекс.Карт (YA_MAP_KEY)';
export const MAP_DESTROY_ERROR = 'Не удалось уничтожить карту:';
